import { css } from '@emotion/react';
import { color, typography } from '@uniquegood/realworld-studio-design';

import { formatCountdown } from '../hooks/useCountdown';

interface CountdownProps {
  /** 남은 시간(초). null 이면 표시하지 않는다. */
  remainingSeconds: number | null;
}

/**
 * 만료까지 남은 시간을 mm:ss 로 표시한다.
 * - 60초 이상: `color.text_subdued`
 * - 60초 미만: `color.palette_secondary_yellow_100` (medium weight, urgent warning)
 *
 * NOTE: 디자인 시안은 orange 톤이었으나 디자인 시스템에 orange 토큰이 없어
 * `palette_secondary_yellow_100` 으로 대체. yellow=경고(회복 가능),
 * red=오류(실패) 의 의미 분리를 유지한다.
 */
export default function Countdown({ remainingSeconds }: CountdownProps) {
  if (remainingSeconds == null) return null;

  const isUrgent = remainingSeconds < 60;

  return (
    <span css={[styles.base, isUrgent && styles.urgent]} aria-live="polite">
      만료까지 {formatCountdown(remainingSeconds)}
    </span>
  );
}

const styles = {
  base: css`
    color: ${color.text_subdued};
    font-size: ${typography.size.s2};
    font-weight: ${typography.weight.regular};
  `,
  urgent: css`
    color: ${color.palette_secondary_yellow_100};
    font-weight: ${typography.weight.medium};
  `
};
